import classes from './Chats.module.scss';
import AccordionItem from '../../../../atoms/accordionItem/AccordionItem';

export default function Chats({ data }) {
    return (
        <div className={`${classes.oChatsSectionBlock} fontRTL`}>
            <div className={classes.TabHead}>
                {data.map((faqData, index) => (
                    <div key={index}>
                        <AccordionItem faqData={faqData} />
                    </div>
                ))}
            </div>
            &nbsp;
        </div>
    );
}
